import React from "react";

// ─────────────────────────────────────────────────────────────────────────────
// HEADER
// ─────────────────────────────────────────────────────────────────────────────
export const Header = ({ currentPage, onNavigate }) => {
  const navLinks = [
    { id: "landing",   label: "Home" },
    { id: "form",      label: "Assessment" },
    { id: "dashboard", label: "Results" },
  ];

  return (
    <header style={{
      position: "fixed",
      top: 0, left: 0, right: 0,
      zIndex: 1000,
      background: "rgba(6,13,26,0.88)",
      backdropFilter: "blur(20px)",
      WebkitBackdropFilter: "blur(20px)",
      borderBottom: "1px solid rgba(34,211,238,0.12)",
      padding: "0 32px",
      height: 64,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    }}>
      {/* Logo */}
      <div
        onClick={() => onNavigate("landing")}
        style={{ display: "flex", alignItems: "center", gap: 12, cursor: "pointer" }}
      >
        <div style={{
          width: 36, height: 36,
          background: "linear-gradient(135deg, #22d3ee22, #3b82f622)",
          border: "1px solid rgba(34,211,238,0.4)",
          borderRadius: 8,
          display: "flex", alignItems: "center", justifyContent: "center",
          fontSize: 18,
          boxShadow: "0 0 12px rgba(34,211,238,0.2)",
        }}>🧠</div>
        <div>
          <div style={{
            fontFamily: "Rajdhani, sans-serif",
            fontSize: 18, fontWeight: 700,
            background: "linear-gradient(90deg,#22d3ee,#3b82f6)",
            WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent",
            letterSpacing: 1,
          }}>
            CareerGenesis AI
          </div>
          <div style={{ fontSize: 9, color: "#6b8aad", letterSpacing: 2, fontFamily: "Exo 2, sans-serif", marginTop: -2 }}>
            CAREER PREDICTION PLATFORM
          </div>
        </div>
      </div>

      {/* Nav Links */}
      <nav style={{ display: "flex", alignItems: "center", gap: 8 }}>
        {navLinks.map(link => {
          const isActive = currentPage === link.id;
          return (
            <button
              key={link.id}
              onClick={() => onNavigate(link.id)}
              style={{
                background: isActive ? "rgba(34,211,238,0.1)" : "transparent",
                border: isActive ? "1px solid rgba(34,211,238,0.35)" : "1px solid transparent",
                color: isActive ? "#22d3ee" : "#6b8aad",
                padding: "6px 16px",
                borderRadius: 6,
                fontFamily: "Rajdhani, sans-serif",
                fontSize: 13, fontWeight: 600, letterSpacing: 1,
                cursor: "pointer",
                transition: "all 0.2s",
                textTransform: "uppercase",
              }}
              onMouseEnter={e => { if (!isActive) { e.currentTarget.style.color = "#94b8d4"; e.currentTarget.style.borderColor = "rgba(34,211,238,0.15)"; } }}
              onMouseLeave={e => { if (!isActive) { e.currentTarget.style.color = "#6b8aad"; e.currentTarget.style.borderColor = "transparent"; } }}
            >
              {link.label}
            </button>
          );
        })}

        {/* CTA Button */}
        <button
          onClick={() => onNavigate("form")}
          style={{
            marginLeft: 8,
            background: "linear-gradient(135deg,rgba(34,211,238,0.15),rgba(59,130,246,0.15))",
            border: "1px solid rgba(34,211,238,0.4)",
            color: "#22d3ee",
            padding: "7px 18px",
            borderRadius: 6,
            fontFamily: "Rajdhani, sans-serif",
            fontSize: 13, fontWeight: 700, letterSpacing: 1,
            cursor: "pointer",
            transition: "all 0.2s",
            textTransform: "uppercase",
          }}
          onMouseEnter={e => { e.currentTarget.style.boxShadow = "0 0 15px rgba(34,211,238,0.3)"; }}
          onMouseLeave={e => { e.currentTarget.style.boxShadow = "none"; }}
        >
          ⚡ Start 
        </button>
      </nav>
    </header>
  );
};

// ─────────────────────────────────────────────────────────────────────────────
// FOOTER
// ─────────────────────────────────────────────────────────────────────────────
export const Footer = ({ onNavigate }) => {
  const year = new Date().getFullYear();

  const columns = [
    {
      title: "Platform",
      links: [
        { label: "Home", id: "landing" },
        { label: "Start Assessment", id: "form" },
        { label: "View Results", id: "dashboard" },
      ],
    },
    {
      title: "Features",
      links: [
        { label: "AI Career Prediction", id: null },
        { label: "Skill Gap Analysis", id: null },
        { label: "Salary Projection", id: null },
        { label: "Roadmap Generator", id: null },
      ],
    },
    {
      title: "Insights",
      links: [
        { label: "Market Trends", id: null },
        { label: "College Placement Data", id: null },
        { label: "Metro Opportunity Map", id: null },
        { label: "Scholarship Guide", id: null },
      ],
    },
  ];

  return (
    <footer style={{
      background: "rgba(6,13,26,0.95)",
      borderTop: "1px solid rgba(34,211,238,0.1)",
      padding: "40px 32px 0",
      marginTop: 0,
    }}>
      <div style={{ maxWidth: 1100, margin: "0 auto" }}>

        {/* Top section */}
        <div style={{
          display: "grid",
          gridTemplateColumns: "2fr 1fr 1fr 1fr",
          gap: 32,
          paddingBottom: 32,
          borderBottom: "1px solid rgba(34,211,238,0.08)",
        }}>
          {/* Brand */}
          <div>
            <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 14 }}>
              <div style={{
                width: 32, height: 32,
                background: "linear-gradient(135deg,#22d3ee22,#3b82f622)",
                border: "1px solid rgba(34,211,238,0.4)",
                borderRadius: 6,
                display: "flex", alignItems: "center", justifyContent: "center",
                fontSize: 15,
              }}>🧠</div>
              <span style={{
                fontFamily: "Rajdhani, sans-serif", fontSize: 16, fontWeight: 700,
                background: "linear-gradient(90deg,#22d3ee,#3b82f6)",
                WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent",
              }}>
                CareerGenesis AI
              </span>
            </div>
            <p style={{ fontSize: 13, color: "#6b8aad", fontFamily: "Exo 2, sans-serif", lineHeight: 1.7, maxWidth: 240 }}>
              AI-powered career prediction platform helping students across India find their ideal career path based on education, skills, and location.
            </p>

            {/* Stats row */}
            <div style={{ display: "flex", gap: 20, marginTop: 16 }}>
              {[["98%","Accuracy"],["5min","Analysis"],["Free","Always"]].map(([v, l]) => (
                <div key={l}>
                  <div style={{ fontFamily: "Rajdhani, sans-serif", fontSize: 18, fontWeight: 700, color: "#22d3ee" }}>{v}</div>
                  <div style={{ fontSize: 10, color: "#6b8aad", letterSpacing: 1 }}>{l}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Link columns */}
          {columns.map(col => (
            <div key={col.title}>
              <div style={{
                fontFamily: "Rajdhani, sans-serif", fontSize: 12,
                color: "#22d3ee", letterSpacing: 2,
                marginBottom: 14, textTransform: "uppercase", fontWeight: 700,
              }}>
                {col.title}
              </div>
              {col.links.map(link => (
                <div
                  key={link.label}
                  onClick={() => link.id && onNavigate(link.id)}
                  style={{
                    fontSize: 13, color: "#6b8aad",
                    fontFamily: "Exo 2, sans-serif",
                    marginBottom: 8,
                    cursor: link.id ? "pointer" : "default",
                    transition: "color 0.2s",
                  }}
                  onMouseEnter={e => { if (link.id) e.currentTarget.style.color = "#22d3ee"; }}
                  onMouseLeave={e => { e.currentTarget.style.color = "#6b8aad"; }}
                >
                  {link.id ? "→ " : "• "}{link.label}
                </div>
              ))}
            </div>
          ))}
        </div>

        {/* Bottom bar */}
        <div style={{
          padding: "16px 0",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: 10,
        }}>
          <span style={{ fontSize: 12, color: "#3d5a74", fontFamily: "Exo 2, sans-serif" }}>
            © {year} CareerGenesis AI. All rights reserved.
          </span>

          {/* Creator credit — centered, glowing */}
          <div style={{
            display: "flex", alignItems: "center", gap: 8,
            background: "linear-gradient(90deg,rgba(34,211,238,0.06),rgba(59,130,246,0.06))",
            border: "1px solid rgba(34,211,238,0.15)",
            borderRadius: 20, padding: "6px 16px",
          }}>
            <span style={{ fontSize: 14 }}>✨</span>
            <span style={{
              fontFamily: "Rajdhani, sans-serif",
              fontSize: 13, letterSpacing: 1.5,
              background: "linear-gradient(90deg,#22d3ee,#a855f7)",
              WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent",
              fontWeight: 700,
            }}>
              Created by Chaturthi and Pooja
            </span>
            <span style={{ fontSize: 14 }}>✨</span>
          </div>

          <span style={{ fontSize: 12, color: "#3d5a74", fontFamily: "Exo 2, sans-serif" }}>
            🇮🇳 Made for India
          </span>
        </div>
      </div>
    </footer>
  );
};

// ─────────────────────────────────────────────────────────────────────────────
// LAYOUT WRAPPER — wraps all pages with Header + Footer
// ─────────────────────────────────────────────────────────────────────────────
export const Layout = ({ children, currentPage, onNavigate }) => (
  <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh", background: "#060d1a" }}>
    <Header currentPage={currentPage} onNavigate={onNavigate} />
    <main style={{ flex: 1, paddingTop: 64 }}>
      {children}
    </main>
    <Footer onNavigate={onNavigate} />
  </div>
);